<template>
    <div v-if="atendimento">

        <ul class="nav nav-tabs" id="tabenf" role="tablist">

            <li class="nav-item" role="presentation">
                <a class="nav-link active" id="proc-tab" data-toggle="tab" href="#proc" role="tab" aria-controls="proc" aria-selected="true">Procedimentos</a>
            </li>

            <li class="nav-item" role="presentation" v-for="(registros, titulo, irx) in lista_registros" :key="irx">
                <a class="nav-link" :id="'reg-' + registros[0].id_modelo_prontuario + '-tab'" data-toggle="tab" 
                    :href="'#' + 'reg-' + registros[0].id_modelo_prontuario" role="tab" aria-controls="'reg-' + irx" aria-selected="false">
                    {{ titulo }}

                    <span v-if="tem_registro_assinado(registros)">
                        <i class="fa-solid fa-file-signature text-success"></i>
                    </span>

                    <span v-else-if="tem_registro_feito(registros)">
                        <i class="fa-solid fa-file-check text-success"></i>
                    </span>
                </a>
            </li>

            <li class="nav-item" role="presentation" v-if="modelos && modelos.length">
                <a href="#" class="nav-link" @click.prevent="add_modelo()">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </a>
            </li>

            <li class="nav-item" role="presentation" v-if="fila && fila.fl_fila_intern">
                <a href="#" class="nav-link" @click.prevent="filtrar_data()">
                    <template v-if="data_filtro">
                        {{ $util.getFormatDate(data_filtro, 'DD/MM') }}
                    </template>
                    <i class="fa-regular fa-calendar-day" v-else></i>
                </a>
            </li>

        </ul>
        
        <div class="tab-content" id="myTabContent">

            <!-- Procedimentos -->
            <div class="tab-pane fade show active" id="proc" role="tabpanel" aria-labelledby="proc-tab">
                <div class="card">
                    <div class="card-body">

                        <!-- EXECUÇÃO -->
                        <az-sub-title title="Execução" class="mb-3">
                            <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="copiar_clipboard(lista_procedimentos_texto)"
                                data-toggle="tooltip" data-placement="top" title="Copiar lista de procedimentos para área de transferência.">
                                <i class="far fa-copy"></i>
                            </button>
                            <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="editar_procedimentos()">
                                <i class="fas fa-edit"></i>
                            </button>
                            <az-submit color="outline-success btn-sm ml-1" @click="salvar_execucao()" :hide_content_while_loading="true">
                                <i class="fa fa-check fa-fw" aria-hidden="true" v-if="!$store.state.loading"></i>
                            </az-submit>
                        </az-sub-title>

                        <div class="small text-muted">Agendado para: 
                            {{ $util.getFormatDate(atendimento.marcacao.dt_inicio) }}
                            {{ atendimento.marcacao.dt_inicio.substr(11,5) }}
                        </div>

                        <template v-for="(proc, ipx) in lista_procedimentos">
                            <div class="row form-row" :key="ipx" v-if="proc.proc.id_classe_procedimento != 1">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="label"
                                        :riscado="!proc.qtd"
                                        :icon="( !proc.qtd ) 
                                            ? 'fa-solid fa-xmark fa-fw text-danger'
                                            : ( !proc.senha && proc.restricao && proc.restricao.autorizacao ? 'fas fa-exclamation-triangle fa-fw' : '' )" 
                                        :buttonColor="proc.restricao && proc.restricao.bloquear ? 'warning' : ''"
                                        :buttonToolTip="( !proc.fl_ativo ) ? 'Procedimento removido na recepção' : 'Procedimento ainda não autorizado.'"
                                        :label="proc.proc.search">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="( proc.item_tabela && proc.item_tabela.in_porte_anestesico )">
                                                <span class="input-group-text" id="basic-addon2" title="Porte Anestésico">P{{ proc.item_tabela.in_porte_anestesico }}</span>
                                            </div>
                                            <div class="input-group-append" v-if="( proc.dados.st_regiao )">
                                                <span class="input-group-text" id="basic-addon2">{{ proc.dados.st_regiao }}</span>
                                            </div>
                                            <div class="input-group-append" v-if="( proc.qtd && proc.qtd > 1 ) || ( proc.dados.st_obs )">
                                                <span class="input-group-text" id="basic-addon2" v-if="proc.dados.st_obs">{{ proc.dados.st_obs }}</span>
                                                <span class="input-group-text" id="basic-addon2" v-if="proc.qtd && proc.qtd > 1">{{ proc.qtd }}x</span>
                                            </div>

                                            <div class="input-group-append" v-if="( proc.status_laudo && proc.fl_ativo !== false )">
                                                <span class="input-group-text" v-if="proc.urg" title="Urgente">
                                                    <i class="fa fa-exclamation-circle text-danger" aria-hidden="true"></i>
                                                </span>
                                                <button type="button" class="btn btn-outline-dark" @click="ver_accession_number(proc)" v-if="proc.an" :title="'AN: '+ proc.an">
                                                    <i class="fas fa-x-ray"></i>
                                                </button>
                                                <button type="button" class="btn" :class="'btn-outline-' + proc.status_laudo.st_color" @click="abrir_laudo_fila_procedimento(proc)">
                                                    {{ proc.status_laudo.search }}
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                    <div v-if="proc.revisor" class="small text-muted ml-3">
                                        Revisor: {{ proc.revisor.search }}
                                    </div>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="A Realizar"
                                        :edicao="( proc.qtd || proc.dados.a_realizar ) ? true : false"
                                        v-model="proc.dados.a_realizar">
                                        <template v-slot:buttonposcb>
                                            <div class="input-group-append" v-if="proc.dados.a_realizar && ( $store.state.user.id_pessoa == atendimento.id_medico || atendimento.delegado )">
                                                <button class="btn btn-sm btn-outline-primary" type="button" @click="abrir_receita_proc (proc)" 
                                                    data-toggle="tooltip" data-placement="top" title="Nova Prescrição">
                                                    <i class="fas fa-pills"></i>
                                                </button>
                                            </div>
                                            <div class="input-group-append" v-else-if="!proc.dados.a_realizar" @click="marcar_realizado(proc)">
                                                <button class="btn btn-sm btn-outline-primary" type="button" @click="proc.dados.a_realizar = true" 
                                                    data-toggle="tooltip" data-placement="top" title="Marcar como a realizar e realizado.">
                                                    <i class="fa-solid fa-check-double"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <template v-if="proc.dados.a_realizar && !proc.dados.reg_info">
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Realização"
                                            v-model="proc.dados.feito">
                                            <template v-slot:buttonposcb>
                                                <div class="input-group-append" v-if=" ( $store.state.user.id_pessoa == atendimento.id_medico || atendimento.delegado ) ">
                                                    <button class="btn btn-sm btn-outline-primary" type="button" @click="proc.dados.reg_info = true" title="Informação Complementar">
                                                        <i class="fas fa-info fa-fw"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-1">
                                        <az-input
                                            sizing="sm"
                                            icon2="fa fa-play"
                                            type="time"
                                            :edicao="proc.dados.feito ? true : false"
                                            :validate="proc.dados.feito && validate"
                                            :required="proc.dados.feito"
                                            v-model="proc.dados.proc_inicio" />
                                    </div>
                                    <div class="col col-12 col-md-1">
                                        <az-input
                                            sizing="sm"
                                            icon2="fa fa-stop"
                                            type="time"
                                            :edicao="proc.dados.feito ? true : false"
                                            v-model="proc.dados.proc_termino" />
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            type="text"
                                            sizing="sm"
                                            icon="fas fa-info fa-fw"
                                            placeholder="Informação complementar..."
                                            v-model="proc.dados.st_obs">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if=" ( $store.state.user.id_pessoa == atendimento.id_medico || atendimento.delegado ) && proc.dados.a_realizar">
                                                    <button class="btn btn-sm btn-outline-primary" type="button" @click="proc.dados.reg_info = false">
                                                        <i class="fa fa-check" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-if="lista_procedimentos && lista_procedimentos.length > 1">
                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <div v-if="lista_procedimentos && lista_procedimentos.filter(item => item.proc.id_classe_procedimento == 1).length"
                                        class="small text-muted mt-2">
                                        <span>
                                            {{ 
                                                lista_procedimentos.filter(item => item.proc.id_classe_procedimento == 1)
                                                    .map(item => item.proc.search)
                                                    .join(', ')
                                            }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-2 d-flex flex-column">
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="marcar_a_realizar()">
                                        Todos
                                    </button>
                                </div>
                            </div>
                        </template>

                        <div class="progress mt-3">
                            <div class="progress-bar bg-success" role="progressbar" :style="'width: ' + percentual_execucao + '%'"></div>
                            <div class="progress-bar bg-warning" role="progressbar" :style="'width: ' + percentual_a_realizar + '%'"></div>
                        </div>

                        <enfermagem-consumo-mat-med 
                            :atendimento="atendimento" 
                            @cancelar_atendimento_solicitacao_estoque="cancelar_atendimento_solicitacao_estoque"
                            @atender_solicitacao_estoque="atender_solicitacao_estoque"
                            @regerar_solic_vacina="regerar_solic_vacina" />

                        <!-- 
                        <div class="mt-3" v-if="atendimento.marcacao.estoque_solicitacoes && atendimento.marcacao.estoque_solicitacoes.length">
                            <div class="small">
                                <span class="badge badge-secondary mr-2">{{ atendimento.marcacao.estoque_solicitacoes.length }}</span>
                                <a href="#" @click.prevent="exibir_solics = !exibir_solics" class="card-link">{{ $route.meta.vacina ? 'Solicitação de Consumo da Vacina' : 'Solicitações de Mat/Med' }}</a>
                            </div>

                            <div class="form-row" v-if="exibir_solics">
                                <div class="col col-12 col-md-6">
                                    <ul class="list-group" v-if="exibir_solics">
                                        <li class="list-group-item d-flex justify-content-between" v-for="(solic, isx) in atendimento.marcacao.estoque_solicitacoes" :key="isx">
                                            <div>
                                                <div>
                                                    #{{ solic.id_estoque_solicitacao }}
                                                    <span class="small text-muted ml-2" v-if="solic.local" title="Local de Armazenagem">{{ solic.local.st_estoque_local }}</span>

                                                    <span v-if="solic.centro_custo" class="small text-muted ml-2" title="Centro de Custo">
                                                        <i class="fa fa-caret-right mr-2" aria-hidden="true"></i>
                                                        {{ solic.centro_custo.search }}
                                                    </span>

                                                    <span class="badge badge-danger ml-2" v-if="solic.fl_estorno">
                                                        <i class="fas fa-undo-alt mr-1"></i>
                                                        Devolução
                                                    </span>
                                                </div>
                                                <div v-for="(esi, iex) in solic.items" :key="iex">
                                                    <i class="fa-solid fa-circle-exclamation text-warning fa-fw mr-2" v-if="esi.links && esi.links.length && !esi.links.find(link => link.movimentacao.in_quantidade)"></i>
                                                    <i class="fa-solid fa-circle text-secondary fa-fw mr-2" v-else-if="!esi.links || !esi.links.length"></i>
                                                    <i class="fa-solid fa-circle-check text-success fa-fw mr-2" v-else></i>

                                                    <span v-if="id_estoque_item_selec && ( esi.item.id_estoque_item == id_estoque_item_selec)" class="badge badge-primary">
                                                        {{ esi.item.search }}    
                                                    </span>
                                                    <span v-else>
                                                        {{ esi.item.search }}
                                                    </span>

                                                    <ul v-if="esi.links && esi.links.length">
                                                        <li v-for="(link, ilx) in esi.links" :key="ilx" class="small">
                                                            {{ link.movimentacao.in_quantidade}}/{{ esi.in_quantidade }}
                                                            <span v-if="link.movimentacao.st_lote" class="ml-3">
                                                                Lote: {{ link.movimentacao.st_lote }}
                                                            </span>
                                                            <span>
                                                                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                                                {{ $util.getFormatDate(link.movimentacao.dt_movimentacao) }}
                                                                {{ link.movimentacao.dt_movimentacao.slice(11,16) }}
                                                            </span>
                                                            <span v-if="link.movimentacao.st_observacao" class="text-muted">
                                                                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                                                {{ link.movimentacao.st_observacao }}
                                                            </span>
                                                        </li>
                                                    </ul>

                                                </div>
                                                
                                            </div>
                                            <div v-if="$route.meta.vacina && atendimento.dt_inicio && atendimento.dt_inicio.slice(0,10) <= $util.hoje()">
                                                <button type="button" class="btn btn-sm btn-outline-danger ml-1" v-if="solic.atendido && solic.items.find(item => item.links.find(link => link.movimentacao.in_quantidade))" @click="cancelar_atendimento_solicitacao_estoque(solic)">
                                                    Cancelar Atendimento
                                                </button>

                                                <button type="button" class="btn btn-primary" v-else-if="!solic.atendido" @click="atender_solicitacao_estoque(solic)">
                                                    Atender
                                                </button>

                                                <button type="button" class="btn btn-success" v-else-if="!isx" @click="regerar_solic_vacina()">
                                                    Re-Solicitar
                                                </button>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col col-12 col-md-6">
                                    <table class="table table-sm table-hover">
                                        <thead>
                                            <tr>
                                                <th>Descrição</th>
                                                <th class="text-right">Qtde</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item_estoque, iix) in lista_matmed_consolidada(atendimento)" :key="iix" :class="id_estoque_item_selec == item_estoque.id_estoque_item ? 'table-primary' : ''">
                                                <td>
                                                    <a href="#" @click.prevent="id_estoque_item_selec = ( id_estoque_item_selec == item_estoque.id_estoque_item ? null : item_estoque.id_estoque_item )" class="card-link">
                                                        {{ item_estoque.st_estoque_item }}
                                                    </a>
                                                </td>
                                                <td class="text-right">{{ item_estoque.qtde }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            
                            <pre v-if="false">{{ atendimento.marcacao.estoque_solicitacoes }}</pre>
                        </div>

                        -->

                        <button type="button" class="btn btn-outline-primary btn-sm mt-3" 
                            :disabled="$store.state.loading"
                            v-if="!atendimento.marcacao.infusao && ( $store.state.user.id_pessoa == atendimento.id_medico || atendimento.delegado ) && !lista_requisicao.length"
                            @click="renovar_requisicao()">
                            Renovar Requisição
                        </button>

                        <template v-if="atendimento.adicoes && atendimento.adicoes.length">
                            <button type="button" class="btn btn-outline-primary btn-sm mt-3 ml-1" 
                                :disabled="$store.state.loading"
                                v-for="(adicao, iax) in atendimento.adicoes"
                                :key="'NA' + iax"
                                @click="nova_adicao(adicao)">
                                <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                                {{ adicao.st_titulo }}
                            </button>        
                        </template>

                        <div v-if="false">
                            <p class="alert alert-info mt-3">Cobrança</p>
                            <procedimentos
                                ref="proced"
                                :idMarcacao="atendimento.marcacao.id_marcacao"
                                :consultorio="true"
                                :assistencia="true"
                                :validate="validate"
                                :posUpdate="procedimentosIncluidos" />
                        </div>  

                        <div class="mt-3" v-if="atendimento.requisicoes && atendimento.requisicoes.length">
                            <order-set-view
                                :exibir_medico="true"
                                :dados="atendimento.requisicoes"
                                type="requisicao"
                                editare="abrir('requisicao', $event)"
                                @refresh="$emit('refresh')"
                                @imprimir="imprimir_receita"
                                :atendimento="atendimento" 
                                @assinar="assinar" />                      
                        </div>

                        <template v-if="atendimento.marcacao.infusao">

                            <div v-if="atendimento.marcacao.infusao" class="alert alert-info d-flex justify-content-between mt-3"> 
                                <div>
                                    {{ atendimento.marcacao.infusao.st_titulo }} 
                                    <span class="badge badge-secondary ml-2" v-if="atendimento.marcacao.in_qt_dia">D{{ atendimento.marcacao.in_qt_dia }}</span>
                                </div>
                                <a href="#" @click.prevent="consultar_contatos('App\\azure\\receita', atendimento.marcacao.infusao.protocolo.receita.id_receita, atendimento.marcacao.infusao.protocolo.receita)" v-if="atendimento.marcacao.infusao && atendimento.marcacao.infusao.protocolo && atendimento.marcacao.infusao.protocolo.receita && atendimento.marcacao.infusao.protocolo.receita.contato">
                                    <span class="badge" :class="( atendimento.marcacao.infusao.protocolo.receita.contato.id_marcacao == atendimento.marcacao.id_marcacao ) ? 'badge-' + atendimento.marcacao.infusao.protocolo.receita.contato.contato_status.st_color : 'badge-light text-muted'">
                                        {{ atendimento.marcacao.infusao.protocolo.receita.contato.contato_status.search }}
                                        / {{ quando(atendimento.marcacao.infusao.protocolo.receita.contato.created_at) }}
                                    </span>

                                    <span v-if="( atendimento.marcacao.infusao.protocolo.receita.contato.id_marcacao == atendimento.marcacao.id_marcacao )" title="Validação da Prescrição para Marcação" class="ml-2">
                                        <i class="fa-regular fa-calendar-check text-success"></i>
                                    </span>
                                </a>
                                <div v-if="atendimento.marcacao.in_qt_ciclo && atendimento.marcacao.infusao.ciclos">
                                    <span class="badge badge-secondary mr-3" v-if="atendimento.marcacao.infusao.protocolo && atendimento.marcacao.infusao.protocolo.receita && atendimento.marcacao.infusao.protocolo.receita.editada">
                                        Editada ({{ atendimento.marcacao.infusao.protocolo.receita.editada.id_receita }})
                                    </span>

                                    <i class="fa-solid fa-arrows-spin mr-2"></i>
                                    {{ atendimento.marcacao.in_qt_ciclo }}/{{ atendimento.marcacao.infusao.ciclos }}

                                    <a href="#" class="card-link ml-3" v-if="$store.state.user.medico && ( $store.state.user.id_pessoa == atendimento.id_medico || atendimento.delegado )" 
                                        @click.prevent="$parent.editar_prescricao_protocolo(atendimento.marcacao)" title="Editar Prescrição do Protocolo">
                                        <i class="fa-solid fa-pen-to-square"></i>
                                    </a>
                                </div>
                                <div v-else-if="atendimento.marcacao.infusao.protocolo && atendimento.marcacao.infusao.protocolo.receita">
                                    <span class="badge badge-secondary mr-3" v-if="atendimento.marcacao.infusao.protocolo.receita.editada">
                                        Editada ({{ atendimento.marcacao.infusao.protocolo.receita.editada.id_receita }})
                                    </span>

                                    <a href="#" class="card-link ml-3" v-if="$store.state.user.medico && ( $store.state.user.id_pessoa == atendimento.id_medico || atendimento.delegado )" 
                                        @click.prevent="$parent.editar_prescricao_protocolo(atendimento.marcacao)" title="Editar Prescrição do Protocolo">
                                        <i class="fa-solid fa-pen-to-square"></i>
                                    </a>
                                </div>
                            </div>

                            <button type="button" 
                                class="btn mr-1" 
                                :class="infusao_validada ? 'btn-outline-danger' : 'btn-primary'"
                                v-if="false && $store.state.user.medico"
                                @click.prevent="validar_prescricao_infusao(atendimento)">
                                {{ infusao_validada ? 'Remover Validação' : 'Validar' }}
                            </button>

                            <button type="button" 
                                class="btn mr-1" 
                                :class="( !infusao_validada ? 'btn-outline-' : 'btn-' ) + ( cobranca ? 'danger' : 'success' )"
                                :disabled="!infusao_validada"
                                v-if="!$store.state.user.medico && atendimento.prescricao_cobranca"
                                @click.prevent="registrar_cobranca(atendimento, atendimento.marcacao.infusao.protocolo.receita)">
                                {{ cobranca ? 'Remover Cobrança' : 'Registrar Cobrança' }}
                            </button>

                            <order-set-view
                                v-if="false"
                                :dados="[atendimento.marcacao.infusao.protocolo.receita]"
                                type="receita"
                                editare="abrir('receita', $event)"
                                @refresh="$emit('refresh')"
                                @imprimir="imprimir_receita"
                                :atendimento="atendimento" 
                                @assinar="assinar"
                                />                      

                            <div v-if="false && atendimento.marcacao.infusao" class="alert-warning">
                                <pre>{{ atendimento.marcacao.infusao }}</pre>
                            </div>

                        </template>

                        <template v-else-if="atendimento.marcacao && atendimento.marcacao.procedimento.id_classe_procedimento == 18 && tem_ciclos (atendimento)">

                            <div v-if="!atendimento.marcacao.nova_infusao" class="mt-2">
                                <button type="button" class="btn btn-outline-success btn-sm" @click.prevent="iniciar_infusao()">
                                    Iniciar Infusão
                                </button>
                            </div>

                            <div class="form-row mt-2" v-else>
                                <div class="col col-12 col-md-2">
                                    <az-input :compact="true" sizing="sm" type="number" label="Ciclo" v-model="atendimento.marcacao.in_qt_ciclo" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input :compact="true" sizing="sm" type="number" label="Dia" v-model="atendimento.marcacao.in_qt_dia" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <button type="button" class="btn btn-sm btn-success btn-sm mr-1" @click.prevent="gerar_infusao()" :disabled="$store.state.loading || !atendimento.marcacao.in_qt_dia || !atendimento.marcacao.in_qt_ciclo">
                                        <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                                    </button>

                                    <button type="button" class="btn btn-sm btn-outline-danger btn-sm" @click.prevent="atendimento.marcacao.nova_infusao = null">
                                        <i class="fa fa-times fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>

                        </template>
                    </div>
                </div>

            </div>

            <!-- Registros -->
            <div class="tab-pane fade" :id="'reg-' + registros[0].id_modelo_prontuario" role="tabpanel" :aria-labelledby="'reg-' + registros[0].id_modelo_prontuario + '-tab'" v-for="(registros, titulo, irx) in lista_registros" :key="irx">
                <div class="card">
                    <div class="card-body">
                        <div v-for="(registro, iregx) in registros" :key="iregx">
                            <div v-if="registro.st_conteudo && registro.st_conteudo.length && ( !data_filtro || registro.created_at.slice(0,10) == data_filtro )">
                                <az-sub-title :title="titulo_registro(registro)">
                                    <template v-if="registro.id_atendimento_registro">
                                        <az-audit-log-button model="atendimentoRegistro" :id="registro.id_atendimento_registro" sizing="sm" />
                                        <button type="button" class="btn btn-outline-secondary btn-sm ml-1" @click="imprimir_registro(registro)">
                                            <i class="fa fa-print" aria-hidden="true"></i>
                                        </button>    
                                    </template>

                                    <!-- Não Pode Editar -->
                                    <template v-if="registro.pode_editar === false">
                                        <button type="button" class="btn btn-outline-secondary btn-sm ml-1" @click="editar_registro(registro)">
                                            <i class="fas fa-lock"></i>
                                        </button>    

                                        <span v-if="registro.doc_certificado && registro.doc_certificado_link">
                                            <a :href="registro.doc_certificado_link" class="btn btn-outline-primary btn-sm ml-1" target="_blank">
                                                <i class="fas fa-file-contract"></i>
                                            </a>
                                        </span>
                                        <span v-else-if="registro.doc_certificado">
                                            <button type="button" class="btn btn-outline-primary btn-sm ml-1" disabled>
                                                <i class="fas fa-file-contract ml-1"></i>
                                            </button>
                                        </span>

                                        <template v-if="registro.doc_certificado || registro.doc_certificado_link">
                                            <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="assinar(registro)" v-if="multiplas_assinaturas && ( registro.id_usuario != $store.state.user.id_usuario ) && $store.state.user.medico" title="Assinar com certificado digital.">
                                                <i class="fa-solid fa-signature"></i>
                                            </button>
                                        </template>
                                    </template>

                                    <!-- Pode Editar -->
                                    <template v-else>
                                        <button type="button" class="btn btn-outline-danger btn-sm ml-1" @click="remover_registro(registro)" v-if="!registro.doc_certificado">
                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                        </button>

                                        <template v-if="registro.edicao">
                                            <az-submit color="outline-success btn-sm ml-1" @click="salvar_registro(registro)" v-if="registro.edicao" :hide_content_while_loading="true">
                                                <i class="fa fa-check fa-fw" aria-hidden="true" v-if="!$store.state.loading"></i>
                                            </az-submit>
                                        </template>

                                        <template v-else>
                                            <span v-if="registro.doc_certificado && registro.doc_certificado_link && registro.id_usuario == $store.state.user.id_usuario">
                                                <a href="#" class="btn btn-outline-danger btn-sm ml-1" @click.prevent="remover_registro(registro)" title="Cancelar documento.">
                                                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                                                </a>
                                            </span>

                                            <span v-if="registro.doc_certificados && registro.doc_certificados.length > 1">
                                                <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="ver_docs(registro)">
                                                    <i class="fas fa-file-contract"></i>
                                                </button>
                                            </span>
                                            <span v-else-if="registro.doc_certificado && registro.doc_certificado_link">
                                                <a :href="registro.doc_certificado_link" class="btn btn-outline-primary btn-sm ml-1" target="_blank">
                                                    <i class="fas fa-file-contract"></i>
                                                </a>

                                                <template v-if="registro.doc_certificado || registro.doc_certificado_link">
                                                    <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="assinar(registro)" v-if="multiplas_assinaturas && ( registro.id_usuario != $store.state.user.id_usuario ) && $store.state.user.medico" title="Assinar com certificado digital.">
                                                        <i class="fa-solid fa-signature"></i>
                                                    </button>
                                                </template>
                                            </span>
                                            <span v-else-if="registro.doc_certificado">
                                                <button type="button" class="btn btn-outline-primary btn-sm ml-1" disabled>
                                                    <i class="fas fa-file-contract ml-1"></i>
                                                </button>

                                                <template v-if="registro.doc_certificado || registro.doc_certificado_link">
                                                    <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="assinar(registro)" v-if="multiplas_assinaturas && ( registro.id_usuario != $store.state.user.id_usuario ) && $store.state.user.medico" title="Assinar com certificado digital.">
                                                        <i class="fa-solid fa-signature"></i>
                                                    </button>
                                                </template>
                                            </span>

                                            <template v-else>
                                                <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="editar_registro(registro)" title="Editar">
                                                    <i class="fas fa-edit"></i>
                                                </button>

                                                <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="assinar(registro)" v-if="registro.id_usuario == $store.state.user.id_usuario" title="Assinar com certificado digital.">
                                                    <i class="fa-solid fa-signature"></i>
                                                </button>
                                            </template>
                                        </template>

                                    </template>

                                </az-sub-title>

                                <div class="d-flex flex-column" v-if="registro.edicao && registro.anterior && registro.anterior.st_conteudo">
                                    <button type="button" class="btn btn-sm btn-outline-primary" @click="herdar_anterior(registro)">
                                        Herdar Registro Anterior 
                                        <i class="fas fa-history mx-3"></i>
                                        {{ $util.getFormatDate(registro.anterior.data_ref ? registro.anterior.data_ref : registro.anterior.created_at) }}
                                    </button>
                                </div>

                                <div class="alert alert-warning" v-if="registro.novo && !registro.id_atendimento_registro">
                                    Novo Registro. Aguardando Gravação.
                                </div>

                                <campos-formulario 
                                    :validate="validate"
                                    v-model="registro.st_conteudo" 
                                    :textos="textos"
                                    :raiz="true" 
                                    :mode="registro.edicao ? 'edit' : 'view'"
                                    :compact="registro.modelo.fl_compact"
                                    :modelo="registro.modelo" />

                                <az-sub-title :title="'Fim: ' + titulo_registro(registro)" class="mt-3" v-if="registro.edicao">
                                    <button type="button" class="btn btn-outline-danger btn-sm ml-1" @click="remover_registro(registro)">
                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                    </button>

                                    <az-submit color="outline-success btn-sm ml-1" @click="salvar_registro(registro)" v-if="registro.edicao" :hide_content_while_loading="true">
                                        <i class="fa fa-check fa-fw" aria-hidden="true" v-if="!$store.state.loading"></i>
                                    </az-submit>

                                    <button type="button" class="btn btn-outline-success btn-sm ml-1" @click="editar_registro(registro)"         
                                        v-else>
                                        <i class="fas fa-edit"></i>
                                    </button>
                                </az-sub-title>
                            </div>
                        </div>

                        <div class="alert alert-warning" v-if="false">
                            <p>{{ titulo }}</p>
                            <pre>{{ registros }}</pre>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Alta -->
            <div class="tab-pane fade" id="alta" role="tabpanel" aria-labelledby="alta-tab">
                <div class="card">
                    <div class="card-body">
                        <pre>{{ modelos }}</pre>
                    </div>
                </div>
            </div>
        </div>

        <pre v-if="false">{{ lista_fixa_barra }}</pre>

                <!-- Info PEP -->

                <div class="d-flex justify-content-end" v-if="lista_complementos.length">
                    <button type="button" class="btn btn-link" @click="toggle_hide_all()">
                        <i class="fas fa-compress-arrows-alt"></i>
                    </button>
                </div>

                <!-- ( atendimento.marcacao && atendimento.marcacao.infusao ) ? calc_peso_altura : null -->
                <order-set-view
                    ref="osv_rec"
                    :filtrar_dia="true"
                    :callback_calc_peso_altura="calc_peso_altura"
                    :dados="lista_prescricao"
                    :pode_aprazar="true"
                    type="receita"
                    :solmatmed="true"
                    @editar="abrir('receita', $event)"
                    @refresh="$emit('refresh')"
                    @imprimir="imprimir_receita"
                    @assinar="assinar"
                    :atendimento="atendimento" />

                <!-- Requisição -->
                <order-set-view
                    :dados="lista_requisicao"
                    type="requisicao"
                    @editar="abrir('requisicao', $event)"
                    @imprimir="imprimir_requisicao"
                    @refresh="$emit('refresh')"
                    @assinar="assinar"
                    :atendimento="atendimento" /> 
                    
                <!-- Prescrição -->
                <order-set
                    :title="( receita && receita.fl_prescricao ) ? 'Prescrição' : 'Receita'"
                    v-model="receita"
                    service="medicamentos.index"
                    :tem_infusao="( ( atendimento.marcacao && atendimento.marcacao.infusao ) ? true : false )"
                    name="receita"
                    ref="receita"
                    :cirurgia="false"
                    :id_anamnese="receita.id_anamnese"
                    :atendimento="atendimento"
                    :id_paciente="atendimento.id_paciente"
                    :assistprocs="lista_procedimentos_ativos.filter(proc => proc.proc.id_classe_procedimento != 1
                        && proc.dados.a_realizar)"
                    @proximo="proxima_prescricao"
                    @refresh="imprimir_receita"
                    @validar_ativas="pos_inclusao_prescricao"
                ></order-set>

                <!-- Requisição -->
                <order-set
                    :title="title_requisicao"
                    v-model="receita"
                    service="procedimentos.index"
                    name="requisicao"
                    ref="requisicao"
                    :cirurgia="false"
                    :id_anamnese="receita.id_anamnese"
                    :atendimento="atendimento"
                    :id_paciente="atendimento.id_paciente"
                    @refresh="imprimir_requisicao"
                ></order-set>

                <!-- Cirurgia -->
                <order-set
                    title="Solicitação de Cirurgia"
                    v-model="requisicao"
                    service="procedimentos.index"
                    name="requisicao"
                    ref="requisicaocirurgia"
                    :cirurgia="true"
                    :id_anamnese="receita.id_anamnese"
                    :atendimento="atendimento"
                    :id_paciente="atendimento.id_paciente"
                    @refresh="imprimir_requisicao"
                ></order-set>

                <!-- Documentos -->
                <div v-if="tags_doc && tags_doc.length" class="text-right mb-1">
                    <a href="#" @click.prevent="search_doc == tag ? search_doc = '' : search_doc = tag" v-for="(tag, itx) in tags_doc" :key="itx">
                        <span class="badge ml-1" :class="tag == search_doc ? 'badge-success' : 'badge-secondary'">
                        {{ tag }}
                        </span>
                    </a>
                </div>

                <div v-for="(proc, ipx) in lista_procedimentos" :key="ipx">

                    <div class="alert alert-light border-warning mb-2" v-for="(doc, idc) in proc.dados.anamnese.documentos" :key="'doc' + idc" 
                        v-show="!search_doc || ( doc.modelo_documento && doc.modelo_documento.js_classes && doc.modelo_documento.js_classes.find(tag => tag == search_doc) )">
                        <span class="close" v-if="$store.state.user.id_usuario == 1 && doc.id_documento_atendimento">
                            <a href="#" class="alert-link mr-1 ml-2" @click.prevent="$util.logAudit('documentoAtendimento', doc.id_documento_atendimento)">
                                <i class="fas fa-question-circle"></i>
                            </a>
                        </span>

                        <span class="close" v-if="pode_assinar && doc.doc_certificado && doc.doc_certificado_link">
                            <a href="#" class="alert-link mr-1 ml-2" @click.prevent="cancelar(doc)">
                                <i class="fa fa-times-circle" aria-hidden="true"></i>
                            </a>
                        </span>
                        <span class="close" v-if="doc.doc_certificado && doc.doc_certificado_link">
                            <a :href="doc.doc_certificado_link" class="alert-link mr-1 ml-2" target="_blank">
                                <i class="fas fa-file-contract"></i>
                            </a>
                        </span>
                        <span class="close" v-else-if="pode_assinar">
                            <a href="#" class="alert-link mr-1 ml-2" @click.prevent="assinar(doc)">
                                <i class="fas fa-signature"></i>
                            </a>
                        </span>
                        <span class="close">
                            <a href="#" @click.prevent="imprimir_documento(doc)" class="alert-link" title="Imprimir">
                                <i class="fas fa-print"></i>
                            </a>
                        </span>
                        <span class="close">
                            <a class="alert-link mx-2" href="#" @click.prevent="$refs['doc.' + proc.dados.id_atendimento_procedimento][0].editar(doc)" title="Editar"
                                v-if="( ( $store.state.user.id_pessoa == ( doc.id_medico ? doc.id_medico : atendimento.id_medico ) ) || atendimento.delegado )">
                                <i class="far fa-file-alt"></i>
                            </a>
                        </span>
                        <span class="close text-danger small" v-if="doc.removendo">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </span>
                        <div>
                            <div :class="doc.hide ? '' : 'mb-3'">
                                <a href="#" @click.prevent="doc.hide = !doc.hide" class="alert-link mr-2" title="Exibição">
                                    <i class="far fa-minus-square" v-if="!doc.hide"></i>
                                    <i class="far fa-plus-square" v-else></i>
                                </a>
                                {{ doc.st_titulo }}
                                <span v-if="doc.modelo_documento && doc.modelo_documento.st_nome && doc.modelo_documento.st_nome != doc.st_titulo" class="text-muted">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ doc.modelo_documento.st_nome }}
                                </span>

                                <span v-if="doc.dt_inclusao" class="ml-3 small text-muted">
                                    {{ $util.getFormatDate(doc.dt_inclusao) }} {{ doc.dt_inclusao.slice(11,16) }}
                                </span>

                                <span v-if="doc.medico_edicao && ( doc.id_medico != atendimento.id_medico )" class="ml-3 small text-muted">
                                    {{ doc.medico_edicao.st_nome_exibicao }}
                                </span>
                            </div>
                            <div v-show="!doc.hide">
                                <div v-if="doc.fl_formulario">
                                    <formulario v-model="doc.estrutura" mode="view" />
                                </div>
                                <div v-else v-html="doc.texto_html"></div>
                            </div>
                        </div>
                    </div>

                    <documento 
                        :podeassinar="pode_assinar"
                        :ref="'doc.' + proc.dados.id_atendimento_procedimento" 
                        :anamnese="proc.dados.anamnese" 
                        :id_paciente="atendimento.id_paciente" 
                        @refresh="imprimir_documento" 
                        @remover="removerDoc" />

                    <div v-for="(atest, ida) in proc.dados.anamnese.atestados" :key="'atest' + ida" >
                        <atestado-view :atest="atest" 
                            :atendimento="atendimento" 
                            @assinar="assinar"
                            @refresh="$emit('refresh')" />
                    </div>

                    <!-- Arquivos -->
                    <div class="alert alert-light" v-if="proc.dados.anamnese.arquivos && proc.dados.anamnese.arquivos.length">
                        <a :href="arq.arquivo.temporary_url" class="text-white"
                            v-for="(arq, iax) in proc.dados.anamnese.arquivos" :key="iax" target="_blank">
                            <span class="badge badge-primary p-2 mr-2 mb-2">
                                <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                {{ arq.arquivo.st_titulo }}  
                            </span>
                        </a>
                    </div>
                </div>

                <!-- Atestado -->
                <form-atestado ref="atestado" :id_anamnese="primeiro_atp.anamnese.id_anamnese" @refresh="$emit('refresh')" />

                <!-- Envio de Arquivo -->
                <az-file-upload
                    ref="upload"
                    :multiple="true"
                    @refresh="$emit('refresh')"
                    :arquivos="primeiro_atp.anamnese.arquivos"
                    :parms="{ model_type: 'anamnese', model_id: primeiro_atp.anamnese.id_anamnese }"
                ></az-file-upload>

                <!-- Fim Info PEP -->

        <div v-if="fila && fila.fl_pos_atendimento && fila.fl_assist_exibir_pep">
            <pep-view-card :marcacao="{ ...atendimento.marcacao, atendimento: atendimento }" :pode_atender="false" :force_view="true" />
        </div>

        <div v-if="atendimento.outras_infusoes && atendimento.outras_infusoes.length" class="mt-3">
            <az-sub-title title="Outras Infusões" />
            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between" v-for="(outra_marcacao, iomx) in atendimento.outras_infusoes" :key="iomx">
                    <div>
                        <div>{{ outra_marcacao.procedimento.st_procedimento }}</div>
                        <div v-if="outra_marcacao.infusao" class="small">{{ outra_marcacao.infusao.st_titulo }}</div>
                    </div>
                    <div>
                        <div v-if="outra_marcacao.id_atendimento">
                            #{{ outra_marcacao.id_atendimento }}

                            <a href="#" @click.prevent="abrir_outro_atendimento(outra_marcacao)" class="card-link" v-if="false">
                                #{{ outra_marcacao.id_atendimento }}
                            </a>
                        </div>
                        <div v-else>
                            Agendado
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div v-if="atendimento.internacao" class="mt-3 alert alert-info d-flex justify-content-between">
            <div>
                Internação: #{{ atendimento.internacao.id_internacao }}
            </div>
            <div v-if="atendimento.internacao.local">
                {{ atendimento.internacao.local.search }}
            </div>
            <div v-else-if="atendimento.internacao.st_leito_nome">
                {{ atendimento.internacao.st_unidade_internacao }} / {{ atendimento.internacao.st_leito_nome }}
            </div>
        </div>

        <div v-if="atendimento.medico_solicitante" class="mt-3 alert alert-info">
            <div>
                Solicitante: {{ atendimento.medico_solicitante.search }}
            </div>
        </div>

        <nav class="navbar fixed-bottom navbar-light bg-light">
            <a class="navbar-brand" href="#">
                {{ atendimento.medico.st_nome_exibicao }}
            </a>
            <div class="mr-3">
                <div class="progress">
                    <div class="indeterminate" v-if="$store.state.loading"></div>
                    <div class="determinate" v-else></div>
                </div>

                <button class="btn btn-sm btn-outline-primary ml-1" type="button" @click="printEtiqueta(atendimento.marcacao)"
                    v-if="atendimento.marcacao" 
                    data-toggle="tooltip" data-placement="top" title="Emitir Etiquetas">
                    <i class="fa-solid fa-tags"></i>
                </button>

                <button class="btn btn-sm btn-outline-primary ml-1" type="button" @click="resumo_medicamentos(atendimento)" 
                    data-toggle="tooltip" data-placement="top" title="Histórico de Medicamentos">
                    <i class="fa-solid fa-book-medical"></i>
                </button>

                <template v-if="pode_alterar">
                    <button class="btn btn-sm btn-outline-danger ml-1" type="button" @click="enviar_arquivo ()" 
                        data-toggle="tooltip" data-placement="top" title="Novo Arquivo Anexo">
                        <i class="fas fa-paperclip"></i>
                    </button>

                    <button class="btn btn-sm btn-outline-success ml-1" type="button"
                        @click="solicitar_matmed ()"
                        v-if="atendimento && atendimento.marcacao"
                        data-toggle="tooltip" data-placement="top" title="Solicitar Mat/Med">
                        <i class="fa-solid fa-boxes-packing"></i>
                    </button>

                    <button class="btn btn-sm btn-outline-primary ml-1" type="button"
                        @click="verColeta (atendimento)"
                        v-if="atendimento && atendimento.marcacao"
                        data-toggle="tooltip" data-placement="top" title="Ver Amostras">
                        <i class="fa-solid fa-vial"></i>
                    </button>
                </template>

                <template v-if="( ( $store.state.user.id_pessoa == atendimento.id_medico ) || atendimento.delegado )">

                    <button class="btn btn-sm btn-outline-info ml-1" type="button"
                        @click="memed ()"
                        v-if="atendimento.medico.st_memed_status == 'A'"
                        data-toggle="tooltip" data-placement="top" title="Memed">
                        <i class="fas fa-medkit"></i>
                    </button>

                    <button class="btn btn-sm btn-outline-secondary ml-1" type="button"
                        @click="abrir_atestado ()"
                        data-toggle="tooltip" data-placement="top" title="Novo Atestado">
                        <i class="fas fa-plus"></i>
                    </button>
                    
                    <button class="btn btn-sm btn-outline-warning ml-1" type="button"
                        @click="incluir_documento()"
                        data-toggle="tooltip" data-placement="top" title="Novo Documento">
                        <i class="far fa-file-alt"></i>
                    </button>

                    <button class="btn btn-sm btn-outline-info ml-1" type="button"
                        @click="abrir ('requisicao')"
                        data-toggle="tooltip" data-placement="top" title="Nova Requisição">
                        <i class="fas fa-heartbeat"></i>
                    </button>

                    <button class="btn btn-sm btn-outline-info ml-1" type="button"
                        @click="abrir ('requisicao', null, true)"
                        data-toggle="tooltip" data-placement="top" title="Solicitar Cirurgia">
                        <i class="fas fa-procedures"></i>
                    </button>

                    <button class="btn btn-sm btn-outline-success ml-1" type="button" @click="abrir ('receita')" 
                        data-toggle="tooltip" data-placement="top" title="Nova Receita">
                        <i class="fas fa-prescription"></i>
                    </button>

                    <button class="btn btn-sm btn-outline-primary ml-1 mr-2" type="button" @click="abrir ('receita', null, true)" 
                        data-toggle="tooltip" data-placement="top" title="Nova Prescrição">
                        <i class="fas fa-pills"></i>
                    </button>

                    <!-- Documentos Fixados -->
                    <div class="btn-group dropup ml-2" v-if="lista_fixa_barra.length">
                        <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-plus-circle"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" href="#" @click.prevent="novo_documento (form)"
                                v-for="(form, iform) in lista_fixa_barra" :key="iform"
                                :title="form.st_modelo_prontuario">
                                <span class="d-block d-lg-none">
                                    <i class="fas fa-plus-circle mr-2"></i>
                                    {{ form.initials }}
                                </span>
                                <span class="d-none d-lg-block">
                                    <i class="fas fa-plus-circle mr-2"></i>
                                    {{ form.st_modelo_prontuario }}
                                </span>
                            </a>
                        </div>
                    </div>


                </template>

                <template v-else-if="( $store.state.user.id_pessoa != atendimento.id_medico && $store.state.user.medico && $store.state.user.medico.conselho && ( $store.state.user.medico.conselho.st_sigla == 'CRM' || $store.state.user.medico.conselho.st_sigla == 'CRN' ) )">

                    <button class="btn btn-sm btn-outline-secondary ml-1" type="button"
                        @click="abrir_atestado ()"
                        data-toggle="tooltip" data-placement="top" title="Novo Atestado">
                        <i class="fas fa-plus"></i>
                    </button>

                    <button class="btn btn-sm btn-outline-info ml-1" type="button"
                        @click="abrir ('requisicao')"
                        data-toggle="tooltip" data-placement="top" title="Nova Requisição">
                        <i class="fas fa-heartbeat"></i>
                    </button>

                    <button class="btn btn-sm btn-outline-success ml-1" type="button" @click="abrir ('receita')" 
                        data-toggle="tooltip" data-placement="top" title="Nova Receita">
                        <i class="fas fa-prescription"></i>
                    </button>

                    <button class="btn btn-sm btn-outline-primary ml-1 mr-2" type="button" @click="abrir ('receita', null, true)" 
                        data-toggle="tooltip" data-placement="top" title="Nova Prescrição">
                        <i class="fas fa-pills"></i>
                    </button>

                </template>

                <!-- CRN -->
                <template v-else-if="( $store.state.user.id_pessoa != atendimento.id_medico && $store.state.user.medico && $store.state.user.medico.conselho && ( $store.state.user.medico.conselho.st_sigla == 'CRN' ) )">

                    <button class="btn btn-sm btn-outline-warning ml-1" type="button"
                        @click="incluir_documento()"
                        data-toggle="tooltip" data-placement="top" title="Novo Documento">
                        <i class="far fa-file-alt"></i>
                    </button>

                </template>

                <slot></slot>
            </div>
        </nav>

        <!-- Modal Inclusão de Registro -->
        <div class="modal fade" id="addRegistroModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Adicionar Anotação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="$route.meta.vacina">
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" :class="proc_selec === ipx ? 'active' : ''" v-for="(proc, ipx) in lista_procedimentos" :key="ipx" @click="proc_selec === ipx ? proc_selec = null : proc_selec = ipx">
                                    {{ proc.proc.search }}
                                </button>
                            </div>
                            
                            <hr>
                        </div>
                        
                        <template v-if="lista_adicao && lista_adicao.length">
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(modelo, imx) in lista_adicao" :key="imx"
                                    :disabled="( $route.meta.vacina && proc_selec === null )"
                                    @click="incluir_modelo_selecionado(modelo)">
                                    <div>
                                        {{ modelo.modelo.st_modelo_prontuario }}
                                    </div>
                                    <div>
                                        <i class="fas fa-lock" v-if="modelo.pode_editar === false"></i>
                                        <i class="fas fa-lock-open" v-else-if="modelo.pode_editar === true"></i>
                                    </div>
                                </button>
                            </div>
                        </template>

                        <template v-else>
                            <az-empty-state msg="Nenhum modelo cadastrado." />
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="selecionarProcedimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="receita">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecionar Procedimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="list-group">
                            <button type="button" class="list-group-item list-group-item-action" v-for="(proc, ipx) in lista_procedimentos" :key="ipx"
                                @click="callback_selecao_proced(proc.dados)">
                                <!-- @click="abrir ('receita', null, true, proc.dados)"> -->
                                {{ proc.proc.search }}
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <memed
            ref="memedRef"
            :atendimento="atendimento"
            @refresh="$emit('refresh')" />

        <assinar-p-e-p ref="assinador" />
        <estoque-atender-solicitacao ref="estoque" @refresh="$emit('refresh')" />

        <!-- Seleção de Campos para Herança -->
        <div class="modal fade" id="assistHerdarAnteriorModal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Atendimento Anterior</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!anterior" />

                        <template v-else>
                            <h4>Confirma buscar os dados do atendimento anterior?</h4>
                            <div>
                                <small class="text-muted">Todos os dados já preenchidos nesse atendimento serão perdidos</small>
                            </div>

                            <az-input
                                class="mt-3"
                                type="checkbox-group"
                                label="Herdar Todos os Campos" 
                                v-model="herdar_todos" />

                            <template v-if="anterior.anterior && anterior.anterior.campos">

                                <div v-for="(campo, icx) in anterior.anterior.campos" :key="icx">
                                    <az-input
                                        type="checkbox-group"
                                        :label="campo.campo" 
                                        v-model="campo.herdar" />
                                </div>

                            </template>

                            <pre v-if="false && anterior">{{ anterior }}</pre>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" :disable="$store.state.loading" @click="confirmar_herdar_anterior ()">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="filtrarDataModal" tabindex="-1" role="dialog" aria-labelledby="filtrarDataModalTitle" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Filtrar Data</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            type="date"
                            label="Data"
                            v-model="edit_data_filtro" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-danger" @click="atualizar_filtro_data(true)" v-if="data_filtro">Remover Filtro</button>
                        <button type="button" class="btn btn-success" @click="atualizar_filtro_data()">Filtrar</button>
                    </div>
                </div>
            </div>
        </div>

        <editar-peso-altura-prescricao ref="pesoAltura" @refresh="$emit('refresh')" />
        <registrar-contatos ref="contatos" titulo="Validação" @refresh="$emit('refresh')" />
        <amostras ref="amostras" />
        <pep-view-receitas ref="viewreceitas" />
        <emitir-etiqueta ref="etiqueta" />
        <laudo-fila-procedimento ref="laudofila" v-if="id_fila_proc" @refresh="$emit('refresh')" />
        <ver-accession-number ref="ver_an" :id_paciente="atendimento ? atendimento.id_paciente : null" />
        <aprazamento-modal ref="aprazamento" @refresh="$emit('refresh')" />
        <aplicacao-modal ref="aplicacaomodal" @refresh="$emit('refresh')" />
        <ver-doc-certificados ref="ver_docs" @refresh="$emit('refresh')" />
        
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import Procedimentos from "../recepcao/Procedimentos.vue";
import CamposFormulario from '../consultorio/CamposFormulario.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import OrderSet from '../consultorio/OrderSet.vue';
import OrderSetView from '../consultorio/OrderSetView.vue';
import Documento from '../consultorio/Documento.vue';
import FormAtestado from "../../shared/atestado/FormAtestado.vue";
import AtestadoView from '../consultorio/AtestadoView.vue';
import AzFileUpload from "../../util/AzFileUpload.vue";
import Formulario from '../consultorio/Formulario.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Memed from '../consultorio/Memed.vue';
import AssinarPEP from '../consultorio/AssinarPEP.vue';
import EstoqueAtenderSolicitacao from '../suprimentos/EstoqueAtenderSolicitacao.vue';
import PepViewCard from '../consultorio/PepViewCard.vue';
import EditarPesoAlturaPrescricao from './EditarPesoAlturaPrescricao.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import Amostras from '../laboratorio/Amostras.vue';
import PepViewReceitas from '../consultorio/PepViewReceitas.vue';
import EmitirEtiqueta from '../../shared/EmitirEtiqueta.vue';
import LaudoFilaProcedimento from '../laudos/LaudoFilaProcedimento.vue';
import VerAccessionNumber from './VerAccessionNumber.vue';
import AprazamentoModal from './AprazamentoModal.vue';
import AplicacaoModal from './AplicacaoModal.vue';
import EnfermagemConsumoMatMed from './EnfermagemConsumoMatMed.vue';
import VerDocCertificados from './VerDocCertificados.vue';

export default {
    data() { 
        return { 
            validate: false, 
            execucao: [], 
            receita: { items: [] }, 
            requisicao: { items: [] },
            callback_selecao_proced: null,
            tmaFim: "", 
            prescr_sem_proced: true, 
            search_doc: "", 
            cobranca: false, 
            montando: true, 
            exibir_solics: false, 
            textos: [], 
            id_estoque_item_selec: null, 
            proc_selec: null, 

            anterior: null, 
            validate_registro: false,

            data_filtro: "", 
            edit_data_filtro: "", 

            sempre_solicitar_prescricao: false, 
            multiplas_assinaturas: false, 
        }
    },

    props: ['atendimento', 'modelos', 'fila', 'id_fila_proc'], 

    components: { 
        Procedimentos, 
        CamposFormulario, 
        AzEmptyState, 
        AzSubTitle, 
        AzInput, 
        AzSubmit, 
        OrderSet,
        OrderSetView,
        Documento,
        FormAtestado, 
        AtestadoView, 
        AzFileUpload, 
        Formulario,
        AzAuditLogButton, 
        Memed,
        AssinarPEP, 
        EstoqueAtenderSolicitacao, 
        PepViewCard, 
        EditarPesoAlturaPrescricao, 
        RegistrarContatos, 
        Amostras, 
        PepViewReceitas, 
        EmitirEtiqueta,
        LaudoFilaProcedimento, 
        VerAccessionNumber, 
        AprazamentoModal, 
        AplicacaoModal, 
        EnfermagemConsumoMatMed, 
        VerDocCertificados, 
    },

    computed: { 
        herdar_todos: { 
            get() { 
                if ( !this.anterior || !this.anterior.anterior || !this.anterior.anterior.campos )
                    return false;

                return !this.anterior.anterior.campos.find(item => !item.herdar);
            },
            set(marca) { 
                if ( this.anterior && this.anterior.anterior && this.anterior.anterior.campos ) { 
                    this.anterior.anterior.campos.forEach(item => item.herdar = marca);
                }
            }
        },

        tags_doc: function () { 
            return _.uniq( 
                    this.lista_procedimentos.flatMap(item => item.dados.anamnese.documentos)
                        .filter(item => item.modelo_documento && item.modelo_documento.js_classes)
                        .flatMap(item => item.modelo_documento.js_classes)
                )
                .sort();
        },

        pode_alterar: function() {
            return this.atendimento &&
                this.atendimento.pode_alterar_prontuario &&
                !this.atendimento.pode_alterar_prontuario.pode
                ? false
                : true;
        },

        primeiro_atp: function() { 
            return _.first(this.atendimento.atendimento_procedimentos, (atp => atp.anamnese));
        },

        lista_procedimentos_ativos: function () { 
            let lista = _.map(
                    _.groupBy(this.atendimento.atendimento_procedimentos.filter(atp => atp.fl_ativo), 'id_procedimento'),
                    (itens) => { 
                        let primeiro = _.first(itens);

                        return { 
                            qtd: _.sumBy(itens, 'in_quantidade'),
                            proc: primeiro.procedimento, 
                            dados: primeiro, 
                            restricao: this.restricao(primeiro), 
                            senha: primeiro.st_codigo_autorizacao, 
                            id_atp: primeiro.id_atendimento_procedimento,
                        };
                    }
                );

            lista = _.orderBy(lista, 'id_atp');

            return lista;
        }, 

        lista_procedimentos: function () { 
            let lista = _.map(
                    _.groupBy(this.atendimento.atendimento_procedimentos, atp => { 
                        return ( this.id_fila_proc && atp && atp.laudo ) ? 'P' + atp.id_atendimento_procedimento : atp.id_procedimento;
                    }),
                    (itens) => { 
                        let primeiro = _.first(itens);

                        return { 
                            qtd: _.sumBy(itens.filter(item => item.fl_ativo), 'in_quantidade'),
                            proc: primeiro.procedimento, 
                            dados: primeiro, 
                            restricao: this.restricao(primeiro), 
                            senha: primeiro.st_codigo_autorizacao, 
                            id_atp: primeiro.id_atendimento_procedimento,
                            status_laudo: ( this.id_fila_proc && itens.length == 1 && primeiro.laudo ) ? primeiro.laudo.status_laudo : null, 
                            an: ( this.id_fila_proc && itens.length == 1 && primeiro.laudo && primeiro.st_an ) ? primeiro.st_an : null,
                            urg: ( this.id_fila_proc && itens.length == 1 && primeiro.fl_urgente ) ? true : false,
                            item_tabela: primeiro.item_tabela,
                            revisor: primeiro.revisor, 
                        };
                    }
                );

            lista = _.orderBy(lista, 'id_atp');

            return lista;
        }, 

        lista_procedimentos_texto: function() { 
            return this.lista_procedimentos.map(item => 
                    ( item.qtd > 1 ? item.qtd + 'x ' : '' ) 
                        + item.proc.search
                        + ( item.dados.st_obs ? ' (' + item.dados.st_obs + ')' : '' ) 
                )
                .join(', ');
        },

        lista_registros: function() { 
            return _.groupBy(
                _.orderBy(
                    this.atendimento.registros.filter(registro => registro.fl_ativo),
                    'fila_laudo_modelo.in_regra_ordem'
                ), 
                'modelo.st_modelo_prontuario'
            );
        },

        lista_requisicao: function() { 
            if ( !this.atendimento )
                return [];

            return this.atendimento.atendimento_procedimentos.flatMap(atp => { 
                return atp.anamnese.requisicao.filter(req => req.fl_ativo)
                    .filter(req => !this.data_filtro || req.dt_inclusao.slice(0,10) == this.data_filtro)
                    .map(item => {
                        return {  
                            ...item, 
                        };
                    });
            });
        },

        lista_prescricao: function() { 
            if ( !this.atendimento )
                return [];

            return this.atendimento.atendimento_procedimentos.flatMap(atp => { 
                if ( !atp.anamnese )
                    return [];
                    
                return atp.anamnese.receita.filter(rec => rec.fl_ativo) // && rec.fl_prescricao)
                    .filter(rec => !this.data_filtro || rec.dt_inclusao.slice(0,10) == this.data_filtro)
                    .map(item => {
                        return {  
                            ...item, 
                        };
                    });

                // titulo: atp.procedimento.search + ( atp.st_obs ? ' (' + atp.st_obs + ')' : '' ),
            });
        },

        lista_adicao: function() { 
            if ( !this.modelos )
                return [];

            return this.modelos.filter(modelo => !modelo.fl_fixo)
                .filter(
                    modelo => modelo.fl_lista 
                    || !this.atendimento.registros.find(registro => registro.id_modelo_prontuario == modelo.id_modelo_prontuario)
                );
        },

        percentual_a_realizar: function() { 
            let marcados = this.lista_procedimentos.filter(item => item.proc.id_classe_procedimento != 1 && item.dados.a_realizar && !item.dados.feito).length
            let total = this.lista_procedimentos.filter(item => item.proc.id_classe_procedimento != 1).length;
            
            return ( total > 0 ) ? Math.round((marcados / total) * 100) : 0;
        },

        percentual_execucao: function() { 
            let marcados = this.lista_procedimentos.filter(item => item.proc.id_classe_procedimento != 1 && item.dados.a_realizar && item.dados.feito).length
            let total = this.lista_procedimentos.filter(item => item.proc.id_classe_procedimento != 1).length;
            
            return ( total > 0 ) ? Math.round((marcados / total) * 100) : 0;
        },

        lista_fixa_barra: function() { 
            if ( !this.atendimento || !this.atendimento.atendimento_procedimentos )
                return [];

            return _.uniqBy(
                this.atendimento.atendimento_procedimentos.flatMap(
                    ap => ap.modelo_prontuario_opcional.concat(
                            ap.modelo_prontuario_opcional_lista.map(
                                item => item.modelo_prontuario
                            )
                        ).map(item => { 
                            item.id_atendimento_procedimento = ap.id_atendimento_procedimento;
                            return item;
                        })
                    ),
                'id_modelo_prontuario'
            );
        },

        lista_complementos: function () { 
            return this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese.receita)
                .concat(this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese.requisicao))
                .concat(this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese.documentos))
                .concat(this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese.atestados));
        },

        infusao_validada: function() { 
            return _.get(this.atendimento.atendimento_procedimentos, '0.js_solics.infusao_valid') ? true : false;
        },

        pode_assinar: function () { 
            let id_medico;
            let medico = this.$store.state.user.medico;

            if ( !medico && this.atendimento ) { 
                if ( this.$store.state.user.delegantes_medicos.find(deleg => deleg.delegante.id_pessoa == this.atendimento.medico.id_pessoa) ) { 
                    id_medico = this.atendimento.medico.id_pessoa;
                }
            } else { 
                id_medico = this.$store.state.user.id_pessoa;
            }

            return this.atendimento && this.atendimento.medico.id_pessoa == id_medico // && this.atendimento.medico.tem_certificado ;
        },

        title_requisicao: function () {
            return ( this.requisicao && this.requisicao.fl_cirurgia )
                ? 'Solicitação de Cirurgia'
                : ( ( this.requisicao && this.requisicao.fl_consulta )
                ? 'Encaminhamento de Consulta'
                : 'Requisição de Exames/Procedimentos' );
        },
    },

    methods: { 
        ver_docs (item) { 
            this.$refs.ver_docs.abrir(item);
        },

        pos_inclusao_prescricao (item) { 
            if ( this.sempre_solicitar_prescricao && item && item.id_receita && item.fl_prescricao ) { 
                this.$refs.osv_rec.solicitar_matmed(item, { solic_auto: true });
            }
        },

        aplicar (receita) { 
            this.$refs.aplicacaomodal.abrir(receita);
        },

        aprazar (receita) { 
            this.$refs.aprazamento.aprazar(receita);
        },

        ver_accession_number (proc) { 
            this.$refs.ver_an.abrir(proc);
        },

        //

        abrir_painel () { 
            this.$refs.painel.abrir(this.atendimento);
        },

        //

        get_laudo_from_atp (atp) { 
            if ( !atp || !atp.laudo )
                return null;

            let laudo = _.cloneDeep(atp.laudo);

            laudo.atendimento_procedimento = _.omit(_.cloneDeep(atp), 'laudo');
            laudo.atendimento_procedimento.atendimento = _.omit(_.cloneDeep(this.atendimento), ['atendimento_procedimento', 'atendimento_procedimentos']);

            return laudo;
        },

        abrir_laudo_fila_procedimento (proc) { 
            if ( !proc || !proc.status_laudo )
                return;

            let atp = this.atendimento.atendimento_procedimentos.find(atp => atp.id_atendimento_procedimento == proc.id_atp); 

            if ( !atp || !atp.laudo )
                return;

            let lista = this.atendimento.atendimento_procedimentos.filter(atp => atp.laudo && atp.laudo.id_status_laudo == proc.status_laudo.id_status_laudo)
                .map(atp => this.get_laudo_from_atp(atp));

            let laudo = lista.find(laudo => laudo.id_atendimento_procedimento == proc.id_atp);

            this.$refs.laudofila.abrir(this.id_fila_proc, laudo, lista);
        },

        //

        tem_registro_assinado (lista) { 
            return lista && lista.find(item => item.id_atendimento_registro && item.doc_certificado_link) ? true : false;
        },

        tem_registro_feito (lista) { 
            return lista && lista.find(item => item.id_atendimento_registro) ? true : false;
        },

        printEtiqueta (marcacao) {
            this.$refs.etiqueta.emitir('marcacao', marcacao);
        },

        quando (data) { 
            if ( data && data.slice(0,10) == this.$util.hoje() ) { 
                return 'Hoje'
            } else { 
                return this.$util.getFormatDate(data, 'DD/MM');
            }
        },  
        gerar_infusao () { 

            if ( this.atendimento.marcacao.nova_infusao ) { 
                this.$util.atualizar(this, { 
                    service: 'pep',
                    func: 'gerar_infusao',
                    dados: { 
                        id_marcacao: this.atendimento.marcacao.id_marcacao, 
                        id_receita: this.atendimento.marcacao.nova_infusao,
                        in_qt_ciclo: this.atendimento.marcacao.in_qt_ciclo,
                        in_qt_dia: this.atendimento.marcacao.in_qt_dia,
                    },
                    toast: true, 
                    callback: () => { 
                        this.$emit('refresh');
                    }
                });
            }
        },

        iniciar_infusao () { 
            this.atendimento.marcacao.nova_infusao = this.tem_ciclos(this.atendimento);
            this.$forceUpdate();
        },

        tem_ciclos (atendimento) { 

            if ( !atendimento || !atendimento.atendimento_procedimentos || !atendimento.atendimento_procedimentos.length )
                return false;

            if ( !atendimento || !atendimento.marcacao || !atendimento.marcacao.id_marcacao )
                return false;

            let teste = atendimento.atendimento_procedimentos.find(atp => { 
                return atp.anamnese && atp.anamnese.receita && atp.anamnese.receita.find(rec => rec.fl_prescricao && rec.fl_ciclos);
            });

            return teste ? _.first(teste.anamnese.receita).id_receita : null; 

        },

        resumo_medicamentos (atendimento) { 
            this.$util.loadItem(this, { 
                service: 'marcacoes',
                func: 'index',
                parms: { 
                    id_paciente: atendimento.id_paciente, 
                    receitas: true, 
                }
            })
            .then(res => { 
                this.$refs.viewreceitas.abrir(res);
            });
        },

        abrir_outro_atendimento(marcacao) { 

            console.log(marcacao);

            /*
            let params = this.$route.params;
            params.id = marcacao.id_atendimento;
            console.log(this.$route);
            this.$router.push({ name: this.$route.name, params: params });
            this.$emit('refresh');
            */

        },

        verColeta (item) { 
            this.$refs.amostras.abrir(item.id_atendimento, false, "");
        },

        marcar_realizado (proc) { 
            // dispose tooltip
            $('.tooltip').tooltip('hide');

            proc.dados.a_realizar = true;
            proc.dados.feito = true;
            proc.dados.proc_inicio = this.$util.agora().slice(0,5);
            proc.dados.proc_termino = this.$util.agora().slice(0,5);
        },

        cancelar(item) {
            if ( !confirm("Confirma cancelar esse registro assinado?") )
                return;

            this.$util.atualizar(this, {
                service: 'pep',
                func: 'item_remover',
                dados: {
                    model_type: item.model.type,
                    model_id: item.model.id,
                },
                callback: () => {
                    this.$emit('refresh');
                }
            });
        },

        consultar_contatos (type, id, receita) { 
            this.$refs.contatos.visualizar(type, id, receita, true);
        },

        calc_peso_altura (receita) { 
            this.$refs.pesoAltura.abrir(receita);
        },

        nova_adicao (adicao) { 
            console.log('adicao', adicao);

            if ( !confirm('Confirma o lançamento de ' + adicao.st_titulo + '?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'internados',
                func: 'novo_atendimento',
                dados: { 
                    id_paciente: this.atendimento.id_paciente, 
                    id_procedimento: adicao.id_procedimento, 
                    id_medico: adicao.id_medico,
                    id_recepcao: adicao.id_recepcao,
                    id_plano: adicao.id_plano, 
                    fl_tele_atendimento: adicao.st_tipo == 'T' ? true : false, 
                    assistencia: true, 
                },
                toast: true, 
                callback: res => { 
                    this.$emit('refresh');
                    console.log('atualizar', res);
                }
            });
        },

        lista_matmed_consolidada (atendimento) { 
            if ( !atendimento || !atendimento.marcacao || !atendimento.marcacao.estoque_solicitacoes ) { 
                return [];
            }

            let lista = atendimento.marcacao.estoque_solicitacoes.flatMap(solic => { 
                return solic.items.map(function (item) { 
                    return { 
                        id_estoque_item: item.id_estoque_item, 
                        st_estoque_item: item.item.st_estoque_item, 
                        qtde: item.links.reduce((acc, link) => acc + ( link.movimentacao.in_quantidade * link.movimentacao.in_fator_saldo * -1 ), 0), 
                    };
                });     
            });

            lista = _.orderBy(
                _.map(
                    _.groupBy(lista, 'id_estoque_item'), 
                    (itens) => { 
                        return { 
                            ...itens[0], 
                            qtde: _.sumBy(itens, 'qtde'),
                        };
                    }
                ),
                'st_estoque_item'
            );

            return lista;
        },

        solicitar_matmed (id_estoque_solicitacao = null) { 

            let solicgeral = this.$util.get_solic_geral();

            if ( solicgeral ) { 
                if ( this.atendimento && this.atendimento.marcacao && this.atendimento.paciente ) { 
                    this.atendimento.marcacao.nome_paciente = this.atendimento.paciente.st_nome;
                }

                let marcacao = this.atendimento ? _.cloneDeep(this.atendimento.marcacao) : null;

                if ( marcacao ) { 
                    marcacao.procs = this.atendimento.atendimento_procedimentos.map(item => { 
                        return {
                            id_marcacao: marcacao.id_marcacao, 
                            id_atendimento_procedimento: item.id_atendimento_procedimento,
                            id_procedimento: item.id_procedimento,
                            search: item.procedimento.search + ' (' + item.id_atendimento_procedimento + ')',
                        };
                    });
                }
                
                solicgeral.solicitar(
                    'S', 
                    { 
                        id_estoque_solicitacao: id_estoque_solicitacao, 
                        marcacao: marcacao, 
                    },
                    () => { 
                        this.$emit('refresh');
                    }
                );

            }

        },

        verificar_items_nao_salvos () { 
            return this.atendimento.registros.filter(registro => registro.fl_ativo)
                .filter(registro => registro.novo && !registro.id_atendimento_registro);
        },

        regerar_solic_vacina () { 
            if ( !confirm('Confirma re-solicitar a vacina?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'estoque',
                func: 'regerar_solic_vacina',
                dados: { 
                    id_marcacao: this.atendimento.marcacao.id_marcacao, 
                },
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        registrar_cobranca (atendimento, receita) { 
            console.log('atendimento', atendimento);
            console.log('receita', receita);

            this.cobranca = !this.cobranca;

            if ( this.cobranca ) { 

                this.$toast.add({
                    severity: "success",
                    summary: "Atenção",
                    detail: "Cobrança registrada com sucesso.",
                    life: 3000
                });

            } else { 

                this.$toast.add({
                    severity: "info",
                    summary: "Atenção",
                    detail: "Cobrança removida com sucesso.",
                    life: 3000
                });

            }
        },

        validar_prescricao_infusao (atendimento) { 
            if ( !confirm('Confirma validar o protocolo?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'infusao',
                func: 'validar',
                dados: { 
                    id_atendimento: atendimento.id_atendimento, 
                }, 
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                },
            });

        },

        cancelar_atendimento_solicitacao_estoque(solic) { 
            this.$refs.estoque.cancelar_atendimento(solic);
        },

        re_atender_solicitacao_estoque (solic) { 
            let outra = _.cloneDeep(solic);

            outra.atendido = false;

            this.$refs.estoque.iniciar_atender(outra);
        },

        atender_solicitacao_estoque(solic) { 
            this.$refs.estoque.iniciar_atender(solic);
        },

        assinar (order) { 
            if ( !this.$store.state.user.medico ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Acesso não disponível.',
                    life: 3000
                });
                return
            }

            this.$refs.assinador.solicitar(
                order.id_anamnese ? order.id_anamnese : -1,
                order.model.type,
                order.model.id,
                () => { 
                    this.$emit('refresh');
                }
            );
        },

        memed() {
            let id_anamnese = this.primeiro_atp ? this.primeiro_atp.anamnese.id_anamnese : null;
            
            if(id_anamnese == null) {
                this.$toast.add({
                    severity: "error",
                    summary: "atenção",
                    detail: "Anamnese não disponível",
                    life: 3000
                });
                return;
            }

            this.$refs.memedRef.show(id_anamnese);
        },

        toggle_hide_all() { 
            let lista = this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese.receita)
                .concat(this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese.requisicao))
                .concat(this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese.documentos))
                .concat(this.atendimento.atendimento_procedimentos.flatMap(item => item.anamnese.atestados));

            let acao = lista.find(item => item && !item.hide) ? true : false;

            lista.forEach(item => { 
                if ( item ) { 
                    item.hide = acao;
                }
            });

            this.$forceUpdate();
        },

        imprimir_registro (registro) { 
            this.$util.print_preview('/imprimir/registro/' + registro.id_atendimento_registro);
        },

        herdar_anterior (registro) { 
            this.herdar_todos = true; 
            this.anterior = registro;

            $('#assistHerdarAnteriorModal').modal('show');
        },

        verificar_campos_herdados(campos) { 
            return campos.map(campo => { 
                if ( campo.type == 'group' || campo.type == 'tabela' ) { 
                    this.verificar_campos_herdados(campo.campos);
                } else { 
                    if ( this.anterior.anterior.campos.find(teste => teste.campo == campo.label && !teste.herdar) ) { 
                        campo.value = "";
                    }
                }

                return campo;
            });
        },

        confirmar_herdar_anterior() { 
            if ( !this.herdar_todos ) { 
                this.verificar_campos_herdados(this.anterior.anterior.st_conteudo);
            }

            this.anterior.st_conteudo = this.anterior.anterior.st_conteudo;
            this.anterior.st_layout_impressao = this.anterior.anterior.st_layout_impressao;
            this.anterior.anterior = null;

            $('#assistHerdarAnteriorModal').modal('hide');
        },

        proxima_prescricao(proc) { 
            this.$nextTick(() => { 
                this.abrir_receita_proc (proc, false);
            });
        },

        marcar_a_realizar() { 
            const marca = this.lista_procedimentos.find(proc => {
                return !proc.dados.a_realizar;    
            }) ? true : false;

            this.lista_procedimentos.forEach(proc => {
                proc.dados.a_realizar = marca;    
            });
        },

        novo_documento(form = null) {
            if (form && form.id_modelo_prontuario) {
                let comp = 'doc.' + form.id_atendimento_procedimento;
                this.$refs[comp][0].novoFormulario(form.id_modelo_prontuario);
            } else {
                alert("em desenvolvimento...");
            }
        },

        copiar_clipboard (text) { 
            if (!navigator.clipboard) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position="fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            } else { 
                navigator.clipboard.writeText(text).then(function() {
                    console.log('Async: Copying to clipboard was successful!');
                }, function(err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Texto copiado para a área de transferência.",
                life: 3000
            });
        },

        abrir_receita_proc (proc, salvar = true) { 
            if ( salvar )
                this.salvar_execucao();

            let presc = this.lista_prescricao.find(item => proc && item.fl_prescricao && item.id_anamnese == proc.dados.anamnese.id_anamnese);

            this.abrir ('receita', presc, true, proc.dados);
        },

        renovar_requisicao() { 
            if ( !confirm('Confirmar renovação da requisição/relatório médico?') )
                return;

            this.$util.atualizar(this, { 
                service: 'enfermagem',
                func: 'renovar_requisicao',
                dados: { 
                    id_atendimento: this.atendimento.id_atendimento, 
                },
                callback: () => { 
                    this.$emit('refresh');
                },
                toast: true,
            });
        },

        enviar_arquivo() {
          this.$refs.upload.abrir();
        },

        abrir_atestado(atestado = null) {
            this.$refs.atestado.abrirModalAtestado({ 
                ...this.atendimento,
                atendimento: this.atendimento
            }, atestado);
        },

        removerDoc(id_documento_atendimento) { 
            let doc = this.lista_procedimentos.flatMap(item => item.dados.anamnese.documentos)
                .find(item => item.id_documento_atendimento = id_documento_atendimento);

            if( doc ) { 
                doc.removendo = true;
                this.$forceUpdate();
            }
        },

        imprimir_documento(doc) { 
            this.$emit('refresh');

            if ( doc ) {
                this.$util.print_preview('imprimir/documento/' + doc.id_documento_atendimento, true);
            }
        },

        editar_procedimentos() { 
            this.$parent.addProcedimento();
        },

        salvar_execucao() { 
            this.$util.atualizar(this, { 
                service: 'enfermagem',
                func: 'salvar_execucao',
                dados: { 
                    id_atendimento: this.atendimento.id_atendimento,
                    lista: this.lista_procedimentos,
                },
                toast: true, 
            });
        },

        titulo_registro(registro) { 
            return ( registro.procedimento ? registro.procedimento.search + ': ' : '' ) 
                + _.get(registro, 'usuario.pessoa.st_nome') + ', ' 
                + ( !registro.created_at 
                    ? 'Novo' 
                    : ( this.$util.getFormatDate(registro.created_at) + ' ' + registro.created_at.substr(11,5) ) )
        },

        agrupar_procedimentos(atendimento) { 
            let lista = _.map(
                    _.groupBy(atendimento.atendimento_procedimentos, 'id_procedimento'),
                    (itens) => { 
                    return { 
                        qtd: _.sumBy(itens, 'in_quantidade'),
                        proc: _.first(itens).procedimento.search, 
                    };
                    }
                );

            lista = _.orderBy(lista, 'proc');

            return lista;
        },

        add_modelo() { 
            this.proc_selec = ( this.lista_procedimentos && this.lista_procedimentos.length == 1 ) ? 0 : null; 

            $('#addRegistroModal').modal('show');
        },

        incluir_modelo_selecionado(modelo) { 

            if ( modelo && modelo.pode_editar === false ) { 

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Edição não disponível para esse usuário.",
                    life: 3000
                });

                return;

            }

            if ( !this.atendimento.registros.find(registro => registro.fl_ativo && registro.edicao && registro.id_modelo_prontuario == modelo.id_modelo_prontuario) ) { 

                this.atendimento.registros.unshift({ 
                    id_atendimento_registro: null, 
                    id_atendimento: this.atendimento.id_atendimento, 
                    id_modelo_prontuario: modelo.id_modelo_prontuario, 
                    created_at: null, 
                    modelo: modelo.modelo,
                    fl_ativo: true,  
                    st_conteudo: modelo.modelo.estrutura ? _.cloneDeep(modelo.modelo.estrutura) : [],
                    st_layout_impressao: modelo.modelo.st_layout_impressao, 
                    id_usuario: this.$store.state.user.id_usuario, 
                    usuario: this.$store.state.user, 
                    edicao: true, 
                    fila_laudo_modelo: modelo, 
                    novo: true, 
                    id_procedimento: this.proc_selec !== null ? _.get(this.lista_procedimentos, this.proc_selec + '.proc.id_procedimento') : null, 
                    procedimento: this.proc_selec !== null ? _.get(this.lista_procedimentos, this.proc_selec + '.proc') : null, 
                });

            }

            $('.modal').modal('hide');

            this.$nextTick(() => { 
                $('#reg-' + modelo.id_modelo_prontuario + '-tab').tab('show');
            });
        },

        editar_registro(registro) { 
            if ( registro.created_at ) { 
                if ( registro.usuario.medico && ( registro.usuario.medico.id_pessoa != this.$store.state.user.id_pessoa ) ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Edição não disponível.",
                        life: 3000
                    });

                    return;
                }
            }

            if ( registro.pode_editar === false ) { 

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Edição não disponível para esse usuário.",
                    life: 3000
                });

                return;

            }

            registro.edicao = true;
        },

        remover_registro(registro) { 
            if ( registro.id_usuario != this.$store.state.user.id_usuario ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Remover",
                    detail: "Somente o responsável pelo registro pode realizar sua remoção.",
                    life: 3000
                });

                return;
            }

            if ( !confirm('Confirmar remoção') )
                return;

            registro.fl_ativo = false;

            if ( registro.id_atendimento_registro ) { 

                this.$util.atualizar(this, { 
                    service: 'atendimento_registros',
                    func: 'store',
                    dados: registro, 
                    callback: () => { 
                        this.$emit('refresh');
                    },
                    toast: true, 
                });

            } else { 

                this.$emit('refresh');

            }
            
        },

        salvar_registro(registro) { 
            
            this.$util.atualizar(this, { 
                service: 'atendimento_registros',
                func: 'store',
                dados: registro, 
                callback: res => { 
                    registro.id_atendimento_registro = res.id_atendimento_registro;
                    registro.edicao = false; 
                    registro.created_at = res.created_at; 
                    registro.model = { 
                        type: 'atendimentoRegistro',
                        id: res.id_atendimento_registro,
                    };
                },
                toast: true, 
            });

        },

        procedimentosIncluidos() { 
            //
        },

        restricao (proc) { 
            if ( !proc || !proc.procedimento || proc.ch_tipo_consulta == 'R' || !proc.procedimento.restricao || !proc.procedimento.restricao.length )
                return {
                    cobertura: true, 
                    autorizacao: false, 
                    bloquear: false,
                    exige_cid: false, 
                    id_operadora: null, 
                    titulo: '', 
                };

            let rest = { 
                cobertura: proc.procedimento.restricao[0].fl_nao_possui_cobertura,
                autorizacao: proc.procedimento.restricao[0].fl_autorizacao_previa, 
                bloquear: proc.procedimento.restricao[0].fl_nao_possui_cobertura ? 
                    proc.procedimento.restricao[0].fl_bloqueia_lancamento : 
                    ( proc.numero_sessao && proc.numero_sessao > 1 ? false : proc.procedimento.restricao[0].fl_senha_autorizacao ),
                exige_cid: proc.procedimento.restricao[0].fl_cid_atendimento,
                id: proc.procedimento.restricao[0].id_restricao_operadora,
                id_operadora: proc.procedimento.restricao[0].id_operadora, 
                titulo: proc.procedimento.restricao[0].st_titulo, 
            };

            return rest;
        },

        incluir_documento(atp = null) { 

            $('#selecionarProcedimentoModal').modal('hide');

            if ( !atp )
                atp = this.primeiro_atp;
            
            const sel_atp = atp ? atp : this.primeiro_atp;

            if ( !atp && this.lista_procedimentos.length > 1 ) { 
                this.callback_selecao_proced = this.incluir_documento;
                $('#selecionarProcedimentoModal').modal('show');
                return;
            }

            if ( !sel_atp ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Procedimento não identificado.",
                    life: 3000
                });
                return;
            }

            const referencia = 'doc.' + sel_atp.id_atendimento_procedimento;

            this.$refs[referencia][0].novoDocumento ();

            //this.$refs[ref].abrir(item);

        },

        selecao_procedimento_para_requisicao(atp) { 
            return this.abrir ('requisicao', null, false, atp);
        },

        selecao_procedimento_para_receita(atp) { 
            return this.abrir ('receita', null, false, atp);
        },

        selecao_procedimento_para_prescricao(atp) { 
            return this.abrir ('receita', null, true, atp);
        },

        abrir(ref, item = null, prescricao_cirurgia = false, atp = null) {

            $('#selecionarProcedimentoModal').modal('hide');

            if (1 == 0 && !this.pode_alterar) {
                this.$toast.add({
                    severity: "error",
                    summary: "atenção",
                    detail: "edição não disponível.",
                    life: 3000
                });
                return;
            }

            if (item) {

                item.nome_procedimento = atp ? atp.procedimento.search : '';

                this[ref] = _.cloneDeep(item);

            } else {

                if ( !atp && ref == 'receita' && ( !prescricao_cirurgia || this.prescr_sem_proced ) ) { 
                    atp = this.primeiro_atp;
                }

                const sel_atp = atp ? atp : this.primeiro_atp;

                item = {
                    id_anamnese: sel_atp ? sel_atp.anamnese.id_anamnese : -1,
                    fl_exibir_data: this.$util.getCookie(ref + '-exibir-data') == 'N' ? false : true,
                    dt_referencia: this.$util.hoje(), 
                    st_tipo_receita: "", 
                    items: [],
                    fl_prescricao: ( ref == 'requisicao' ? false : prescricao_cirurgia ), 
                    fl_cirurgia: ( ref == 'receita' ? false : prescricao_cirurgia ), 
                    nome_procedimento: sel_atp ? sel_atp.procedimento.search : '', 
                    cid: null, 
                    cid2: null, 
                    cid3: null, 
                };

                this.receita = {
                    id_anamnese: item.id_anamnese,
                    st_tipo_receita: "", 
                    items: [],
                    fl_prescricao: ( ref == 'requisicao' ? false : prescricao_cirurgia ), 
                    fl_cirurgia: ( ref == 'receita' ? false : prescricao_cirurgia ), 
                };

                this.requisicao = {
                    id_anamnese: item.id_anamnese,
                    fl_cirurgia: prescricao_cirurgia, 
                    items: []
                };

                if ( !atp && this.lista_procedimentos.length > 1 ) { 
                    this.callback_selecao_proced = ( ref == 'requisicao'
                        ? this.selecao_procedimento_para_requisicao
                        : ( prescricao_cirurgia
                            ? this.selecao_procedimento_para_prescricao
                            : this.selecao_procedimento_para_receita
                        )
                    );

                    $('#selecionarProcedimentoModal').modal('show');
                    return;
                }

            }

            if ( ref == 'requisicao' && ( prescricao_cirurgia || item.fl_cirurgia ) ) {
                ref = 'requisicaocirurgia';
            } else if ( ref == 'requisicao' && ( item.fl_consulta ) ) {
                // ref = 'requisicaoconsulta';
            }

            this.$refs[ref].abrir(item);

        },

        imprimir_receita(dados) {
            this.$emit("refresh");

            if ( !dados )
                return;

            this.$util.print_preview('imprimir/receita/' + dados.id_receita, true);
        },

        imprimir_requisicao(dados) {
            this.$emit("refresh");

            if ( !dados )
                return;

            this.$util.print_preview('imprimir/requisicao/' + dados.id_requisicao, true, { modelo: dados.modelo }, true);
        },

        obter_textos() { 

            if ( this.atendimento && this.atendimento.atendimento_procedimento ) { 

                this.$util.loadItem(this, { 
                    service: 'textos_padrao',
                    func: 'index',
                    parms: { 
                        id_atendimento: this.atendimento.id_atendimento, 
                        id_procedimento: this.atendimento.atendimento_procedimento.id_procedimento, 
                    },
                    configs: [
                        'assistencia-solicitacao-prescricao-automatica', 
                        'assistencia-multiplas-assinaturas', 
                    ]
                })
                .then(res => {
                    this.textos = res;
                    this.sempre_solicitar_prescricao = !!this.$store.state.contexto['assistencia-solicitacao-prescricao-automatica'];
                    this.multiplas_assinaturas = !!this.$store.state.contexto['assistencia-multiplas-assinaturas'];
                });

            }

        },
        
        filtrar_data () { 
            $('#filtrarDataModal').modal('show');
        },

        atualizar_filtro_data (remover = false) { 
            if (remover) {
                this.edit_data_filtro = "";
            }

            this.data_filtro = this.edit_data_filtro;
            $('#filtrarDataModal').modal('hide');
        },

    },

    mounted() { 
        this.$nextTick(() => { 
            this.montando = false;
        });

        this.exibir_solics = this.$route.meta.vacina ? true : false;

        this.obter_textos();
    },
}
</script>
